import React from "react";
import Card from "../../components/page/Card";
import useApi from "../../hooks/useApi";
import UsuarioApiClient from "../../api/usuario.js";
import UsuariosDatatable from "./Usuarios/UsuariosDatatable.jsx";
import CommonSwal from "../../components/Swal/commonSwal.jsx";
import { AppContext } from "../../contexts/AppContext.jsx";
import UsuarioModal from "./Usuarios/UsuarioModal.jsx";
import OptionsSwal from "../../components/Swal/optionsSwal.jsx";
import ErrorSwal from "../../components/Swal/errorSwal.jsx";
import Validation from "../../helpers/Validation.js";
import Authentication from "../../helpers/Authentication.js";

function Usuarios() {
  const [usuarios, setUsuarios] = React.useState([]);
  const { session } = React.useContext(AppContext);
  const [usuarioModal, setUsuarioModal] = React.useState(false);
  const [modalProps, setModalProps] = React.useState(true);
  const [values, setValues] = React.useState({ usuarioNivel: "0" });

  const { request: getUsuarios, data: usuariosResponse } = useApi(
    UsuarioApiClient.getUsuarios
  );
  const atualizaStatusUsuarioApi = useApi(
    UsuarioApiClient.atualizaStatusUsuario
  );
  const novoUsuarioApi = useApi(UsuarioApiClient.novoUsuario);
  const getUsuarioApi = useApi(UsuarioApiClient.getUsuario);
  const updateUsuarioApi = useApi(UsuarioApiClient.updateUsuario);

  //Busca usuarios ao renderizar tela
  React.useEffect(() => {
    const buscarUsuarios = async () => {
      await getUsuarios();
    };
    buscarUsuarios();
  }, [getUsuarios]);

  //Define o retorno do backend nos valores dos campos
  React.useEffect(() => {
    if (!usuariosResponse) return;
    if (session.codigo === "99") {
      setUsuarios(usuariosResponse);
    } else {
      setUsuarios(usuariosResponse.filter((usuario) => usuario.codigo === "0"));
    }
  }, [session.codigo, usuariosResponse]);

  const atualizaStatusUsuario = (id, ativo) => {
    const formData = new FormData();
    formData.append("ativo", ativo);
    formData.append("id", id);
    formData.append("uid_empresa", session.empresa_uid);

    const atualizaStatusResponse = atualizaStatusUsuarioApi.request(formData);
    if (!atualizaStatusResponse) return;
    CommonSwal({
      icon: "success",
      title: "Status atualizado com sucesso!",
    }).then(async () => {
      await getUsuarios();
    });
  };

  const togUsuarioModal = async (novo, uid = null) => {
    setModalProps(novo);
    novo ? setValues({ usuarioNivel: "0" }) : await setUsuario(uid);
    setUsuarioModal(!usuarioModal);
  };

  const salvaNovoUsuario = async () => {
    const formData = new FormData();
    formData.append("nome", values.nome);
    formData.append("email", values.email);
    formData.append("codigo", values.usuarioNivel);
    formData.append("senha", values.senha);
    formData.append("confirmSenha", values.confirmSenha);
    formData.append("uid_empresa", session.empresa_uid);

    const validacoes = handleUserValidation(formData, true);
    if (validacoes) return ErrorSwal({ ...validacoes });

    const novoUsuarioResponse = await novoUsuarioApi.request(formData);
    if (!novoUsuarioResponse) return;
    CommonSwal({ ...novoUsuarioResponse }).then(() => {
      setUsuarioModal(false);
    });
    getUsuarios();
  };

  const setUsuario = async (uid) => {
    const getUsuarioResponse = await getUsuarioApi.request(uid);
    if (!getUsuarioResponse) return;
    setValues({
      uid: getUsuarioResponse.uid,
      nome: getUsuarioResponse.nome,
      email: getUsuarioResponse.email,
      emailAntigo: getUsuarioResponse.email,
      usuarioNivel: getUsuarioResponse.codigo,
    });
  };

  const editaUsuario = async () => {
    const formData = new FormData();
    formData.append("uid", values.uid);
    formData.append("nome", values.nome);
    formData.append("email", values.email);
    formData.append("emailAntigo", values.emailAntigo);
    formData.append("codigo", values.usuarioNivel);

    const validacoes = handleUserValidation(formData, false);
    if (validacoes) return ErrorSwal({ ...validacoes });

    if (await verificaEmailAlterado()) return;

    const updateUsuarioResponse = await updateUsuarioApi.request(formData);
    if (!updateUsuarioResponse) return;
    CommonSwal({ ...updateUsuarioResponse }).then(() => {
      setUsuarioModal(false);
    });
    getUsuarios();
  };

  const handleUserValidation = (formData, novo) => {
    if (Validation.verificarForm(formData))
      return {
        text: "Favor preencher todos os dados obrigatórios.",
      };
    if (values.senha !== values.confirmSenha && novo)
      return {
        text: "As senhas precisam ser iguais.",
      };
    const validacaoSenha = Authentication.verificarSenha(values?.senha);
    if (validacaoSenha && novo)
      return {
        html: validacaoSenha,
      };
    if (Validation.validarEmails(values.email))
      return {
        text: "E-mail inválido.",
      };
  };

  const verificaEmailAlterado = () => {
    return new Promise((resolve) => {
      if (values.email === values.emailAntigo) return resolve(false);
      OptionsSwal({
        title: "Você realmente deseja alterar o e-mail de acesso à sua conta?",
        text: "Esta ação modificará seu login e o endereço para recuperação de senha. Prosseguir com a alteração?",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(false);
        } else {
          setValues({
            ...values,
            email: values.emailAntigo,
          });
          resolve(true);
        }
      });
    });
  };

  return (
    <Card>
      <div className="row">
        <UsuariosDatatable
          usuarios={usuarios}
          atualizaStatusUsuario={atualizaStatusUsuario}
          togUsuarioModal={togUsuarioModal}
        />
      </div>
      <UsuarioModal
        usuarioModalHook={{ usuarioModal, setUsuarioModal }}
        valuesHook={{ values, setValues }}
        modalProps={modalProps}
        salvaNovoUsuario={salvaNovoUsuario}
        editaUsuario={editaUsuario}
      />
    </Card>
  );
}

export default Usuarios;
